import { BaseCandidate } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';
import { DEFAULT_CANDIDATE_PHOTO } from '../CandidateStore';
import { DEFAULT_CANDIDATE } from '~/consts/candidates';

const onSelectCandidate = (candidateId: BaseCandidate['id']) => {
    const { candidateStore, tabStore } = getStore();
    candidateStore.setSelectedCandidateEdit(DEFAULT_CANDIDATE);
    candidateStore.setPreviewCandidatePhoto(null);
    candidateStore.setCandidatePhoto(DEFAULT_CANDIDATE_PHOTO);
    candidateStore.setSelectedCandidateId(candidateId);
    tabStore.setIsTabContentReset(false);
    candidateStore.setIsEditMode(true);
    candidateStore.setIsCreateMode(false);
    candidateStore.getCandidateAttributeOptions();
};

export default onSelectCandidate;
